import React from 'react';
import { injectIntl } from 'react-intl';
import Icon from '../../atoms/icons/Icon';
import Paragraph from '../../atoms/paragraphs/Paragraph';
import PropTypes from 'prop-types';
import { Tooltip } from 'react-tooltip';

/**
 * @param {Object} props - Component props
 * @param {Array} props.plans_features - Array of plan features with name and enabled status
 * @param {string} props.className - Additional CSS classes
 * @returns {React.ReactElement} PlansFeaturesTable component
 */
const PlansFeaturesTable = ({ intl, ...props }) => {
  const { plans_features = [], className = '', selectedPlan } = props;

  return (
    <div className={`plan-features-table ${className}`}>
      <div className='container-fluid p-0'>
        <div className='row row-cols-1 row-cols-sm-2 row-cols-md-3 row-cols-lg-4'>
          {plans_features.map((feature, index) => (
            <div key={`feature-${index}`} className='d-flex col px-2 my-1'>
              <div
                className={`plan-feature-item d-flex flex-row align-items-center p-2 my-auto w-100 ${
                  selectedPlan?.features?.includes(feature.id)
                    ? 'feature-enabled'
                    : 'feature-disabled'
                }`}
                data-tooltip-id={
                  !selectedPlan?.features?.includes(feature.id)
                    ? 'disabledFeature_' + feature.id
                    : ''
                }
                data-tooltip-delay-hide={250}
              >
                <Icon className={'fas fa-circle-check'} />

                <Paragraph className='text-paragraph ms-2 mb-0 user-select-none'>
                  {intl.messages[`planFeature_${feature.key}`]}
                </Paragraph>
              </div>

              <Tooltip
                id={`disabledFeature_${feature.id}`}
                className='tooltip'
                content={intl.messages['disabledFeatureTooltip']}
                place='bottom'
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

PlansFeaturesTable.propTypes = {
  plans_features: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    })
  ),
  className: PropTypes.string,
};

export default injectIntl(PlansFeaturesTable);
